import { useEffect, useRef, useState } from 'react';

export const useKanbanVisibility = (initialKanBanColumns) => {
  const [kanbanColumns, setKanbanColumns] = useState(initialKanBanColumns);
  const [kanbanFilteredColumns, setKanbanFilteredColumns] =
    useState(initialKanBanColumns);
  const [kanbanHiddenColumns, setKanbanHiddenColumns] = useState([]);

  const kanbanColumnsRef = useRef(kanbanColumns);
  kanbanColumnsRef.current = kanbanColumns;

  const handleKanbanVisibility = (column) => {
    // reset columns functionality
    if (!column) {
      setKanbanColumns(initialKanBanColumns);
      setKanbanFilteredColumns(initialKanBanColumns);
      setKanbanHiddenColumns([]);
      return;
    }

    const columnStatus = kanbanColumns.map((col) => {
      return {
        ...col,
        value: col.key === column.key ? !col.value : col.value,
      };
    });

    setKanbanColumns(columnStatus);
    setKanbanFilteredColumns(columnStatus.filter((col) => col.value));
    setKanbanHiddenColumns(columnStatus.filter((col) => !col.value));
  };

  useEffect(() => {
    const visibilityMap = kanbanColumnsRef.current.reduce((acc, col) => {
      acc[col.key] = col.value;
      return acc;
    }, {});

    const merged = initialKanBanColumns.map((col) => ({
      ...col,
      value: col.key in visibilityMap ? visibilityMap[col.key] : col.value,
    }));

    setKanbanColumns(merged);
    setKanbanFilteredColumns(merged.filter((col) => col.value));
    setKanbanHiddenColumns(merged.filter((col) => !col.value));
  }, [initialKanBanColumns]);

  return {
    handleKanbanVisibility,
    kanbanColumns,
    kanbanFilteredColumns,
    kanbanHiddenColumns,
  };
};

export default useKanbanVisibility;
